import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CustomerAccountReport } from './Pages';

export const CustomerAccountReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CustomerAccountReport} />
    </Fragment>
)